<template>
  <div style="display: inline-block">
    <v-tooltip v-if="$attrs.icon" top>
      <template #activator="{ on }">
        <v-icon
          :class="`${$attrs.color || 'primary'}--text cursor`"
          @click="dialogConfirm = true"
          v-on="on"
        >
          {{ $attrs.icon }}
        </v-icon>
      </template>
      <span>{{ text }}</span>
    </v-tooltip>
    <v-btn v-else small ripple v-bind="$attrs" @click="dialogConfirm = true">
      {{ text }}
    </v-btn>

    <dialog-confirm
      v-model="dialogConfirm"
      :loading="loading"
      :text="confirmText"
      :text-info="textInfo"
      @submit="submit"
    />
  </div>
</template>

<script>
import DialogConfirm from '@/components/widgets/dialog/DialogConfirm'
export default {
  name: 'ButtonConfirm',
  components: { DialogConfirm },
  props: {
    type: {
      type: String,
      require: true,
    },
    text: {
      type: String,
      require: false,
    },
    textInfo: {
      type: String,
      require: false,
    },
    colorText: {
      type: String,
      require: false,
    },
    loading: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  data() {
    return {
      dialogConfirm: false,
    }
  },
  computed: {
    confirmText() {
      let field = this.text || this.$t('action.buttons.confirm')
      field =
        `<span class="text-uppercase ${
          this.colorText || this.$attrs.color
        }--text">` +
        field +
        '</span>'
      return this.$t('titles.global.confirmMessage', {
        field,
      })
    },
  },
  methods: {
    submit() {
      this.dialogConfirm = false
      this.$emit('submit')
    },
  },
}
</script>
